// extracted by mini-css-extract-plugin
export default {"header":"style_header__Z4o9h","title":"style_title__2CHvB","subtitle":"style_subtitle__IzESo","subtitleCentral":"style_subtitleCentral__Igq25"};